/**
 * @fileoverview Module for `src/Verify.js`.
 */

import React, { Component } from 'react';
import propTypes from 'prop-types';
import Header from './page/Header';
import Footer from './page/Footer';
import Qualify from './Qualify';
import axios from 'axios';
import GA from './lib/GoogleAnalytics';

/**
 * Verification page wrapper that advances users through signup qualification.
 */
class Verify extends Component {
  /**
   * Initializes user and partner state from props.
   *
   * @param {Object} props - Component props.
   * @param {Object} props.user - The authenticated user record.
   * @param {Object} props.auth - Auth client for API calls.
   * @param {Object} props.match - React Router match for path detection.
   */
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.user,
      user_partners: [],
    };
  }

  static get propTypes() {
    return {
      user: propTypes.object,
      auth: propTypes.object,
      match: propTypes.object,
    };
  }

  /**
   * Loads partner affiliations for the signed-in user.
   *
   * @returns {Promise<void>} Resolves after partner state is updated.
   */
  async getUserPartners() {
    const accessToken = await this.props.auth.getAccessToken();
    const res = await axios
      .get(`${ process.env.REACT_APP_API_URL }/v1/users/self/partners`,
        {
          headers: {
            Authorization: 'Bearer '.concat(accessToken),
          },
        });
    this.setState({ user_partners: res.data });
  }

  /**
   * Adds the Swing Left partner association for opted-in users.
   *
   * @returns {Promise<void>} Resolves when partner assignment is created.
   */
  addSLPartner = async () => {
    GA.trackEvent({ category: 'userPartnerAdd', action: 'swingleft' });
    const data = {
      partner: 'swingleft',
      source: 'new_user_sl_optin',
    };
    const accessToken = await this.props.auth.getAccessToken();
    await axios.post(`${ process.env.REACT_APP_API_URL }/v1/users/self/partners`, data, {
      headers: {
        Authorization: 'Bearer '.concat(accessToken),
      },
    });
  };

  /**
   * Persists profile updates gathered during qualification.
   *
   * @param {Object} data
   * @returns {Promise<void>} Resolves after user data is updated.
   */
  updateUser = async (data) => {
    GA.trackEvent({ category: 'profile_update', action: Object.keys(data).sort().join('-') });
    const accessToken = await this.props.auth.getAccessToken();
    await axios.patch(`${ process.env.REACT_APP_API_URL }/v1/users/self`, data, {
      headers: {
        Authorization: 'Bearer '.concat(accessToken),
      },
    });
    this.setState({ user: { ...this.state.user, ...data }});
  };

  /**
   * Loads partner affiliations on mount.
   */
  componentDidMount() {
    this.getUserPartners();
  }

  /**
   * Renders the verification page with the Qualify wizard inside
   * header and footer chrome.
   *
   * @returns {JSX.Element} The verification page.
   */
  render() {
    return (
      <div>
        <Header path={ this.props.match.path } />
        <div className='verify-page py-5 d-flex justify-content-center' style={{ backgroundColor: '#FDFAF0' }}>
          <div className='verify-container d-flex'>
            <div className='verify-card w-100 align-self-center'>
              <Qualify
                addSLPartner={ this.addSLPartner }
                auth={ this.props.auth }
                partners={ this.state.user_partners }
                updateUser={ this.updateUser }
                user={ this.state.user }
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Verify;
